<template>
  <div class="courseware" ref="wrap">
    <div
      class="container"
      :style="{ width: width + 'px', height: height + 'px' }"
    >
      <el-tooltip
        class="anchor-item"
        v-show="currentImgId == a.imageId"
        :style="{ top: a.pointY + '%', left: a.pointX + '%' }"
        v-for="(a, idx) in anchorList"
        :key="idx"
        effect="dark"
        :content="a.title"
        placement="top"
      >
        <i
          :class="{
            'el-icon-link': a.type == 2,
            'el-icon-video-play': a.type == 1,
          }"
          @click="handleClick(a)"
        ></i>
      </el-tooltip>
      <el-carousel
        trigger="click"
        indicator-position="none"
        :autoplay="false"
        :loop="false"
        ref="carousel"
        @change="handleChange"
      >
        <el-carousel-item v-for="item in PPTList" :key="item.imageId">
          <img class="pptImg" :src="item.url" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog
      :visible.sync="showVideo"
      width="40%"
      :close-on-click-modal="false"
    >
      <video
        v-if="showVideo"
        style="width: 100%; max-height: 55vh"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { startPPT, during, atLast } from "@/api/record";
import { chapterPPT } from "@/api/chapter";
const RATIO = 9 / 16;

export default {
  name: "courseware",
  data() {
    return {
      PPTList: [],
      totalCount: 0,
      historyId: null,
      classChapterId: null,
      activeIdx: 0,
      width: 0,
      height: 0,
      showVideo: false,
      videoUrl: "",
    };
  },
  mounted() {
    this.slideBanner();
    let wrapHeight = this.$refs.wrap.offsetHeight;
    this.height = wrapHeight;
    this.width = this.height / RATIO;
  },
  activated() {
    if (this.classChapterId != this.$route.query.classChapterId) {
      this.getPPT();
      this.delay = setTimeout(() => {
        this.handleStart();
      }, 3000);
    } else this.handleDuring();
  },
  deactivated() {
    this.classChapterId = this.$route.query.classChapterId;
    clearInterval(this.timerId);
    clearTimeout(this.delay);
  },
  computed: {
    anchorList() {
      if (this.PPTList[this.activeIdx]) {
        return this.PPTList[this.activeIdx].pointEntityList;
      } else {
        return [];
      }
    },
    currentImgId() {
      return this.PPTList[this.activeIdx]?.imageId;
    },
  },
  methods: {
    getPPT() {
      this.$loading.show();
      chapterPPT(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          // console.log(res)
          this.PPTList = res.data;
          this.totalCount = res.data.length;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 开始
    handleStart() {
      startPPT(this.$route.query.classChapterId).then((res) => {
        if (res.code == 0) {
          this.historyId = res.data;
          console.log("PPT开始观看...");
          this.handleDuring();
        } else {
          console.log(res.msg);
        }
      });
    },
    // 进行中
    handleDuring() {
      if (this.historyId) {
        if (this.totalCount == 1) this.handleEnd();
        this.timerId && clearInterval(this.timerId);
        this.timerId = setInterval(() => {
          during(this.historyId).then((res) => {
            if (res.code == 0) {
              console.log("PPT观看中...");
            } else {
              console.log(res.msg);
            }
          });
        }, 5000);
      }
    },
    // 翻到最后一页
    handleEnd() {
      if (this.historyId) {
        atLast(this.historyId).then((res) => {
          if (res.code == 0) {
            console.log("PPT观看到最后一页");
          } else {
            console.log(res.msg);
          }
        });
      }
    },
    handleChange(idx) {
      this.activeIdx = idx;
      if (idx + 1 == this.totalCount) this.handleEnd();
    },
    slideBanner() {
      let vm = this;
      //选中item的盒子
      let box = document.querySelector(".el-carousel__container");
      //手指起点X坐标
      let startPoint = 0;
      //手指滑动重点X坐标
      let stopPoint = 0;

      //重置坐标
      let resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      };

      let start = function (e) {
        startPoint = e.changedTouches[0].pageX;
      };
      let move = function (e) {
        stopPoint = e.changedTouches[0].pageX;
      };
      let end = function () {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", end);

        // console.log("1：" + startPoint);
        // console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          vm.$refs.carousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          vm.$refs.carousel.prev();
          return;
        }
      };

      //手指按下
      box.addEventListener("touchstart", start);
      //手指滑动
      box.addEventListener("touchmove", move);
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", end);

      let mouseStart = function (e) {
        document.addEventListener("mousemove", mouseMove);
        document.addEventListener("mouseup", end);
        startPoint = e.pageX;
      };
      let mouseMove = function (e) {
        stopPoint = e.pageX;
      };

      //鼠标按下
      box.addEventListener("mousedown", mouseStart);
    },
    handleClick(anchorPoint) {
      if (anchorPoint.type == 2) {
        // 链接
        let reg = /(http|https):\/\/([\w.]+\/?)\S*/;
        let head = anchorPoint.link.match(reg) ? "" : "http://";
        window.open(head + anchorPoint.link, "_blank");
      } else {
        // 视频
        this.videoUrl = anchorPoint.link;
        this.showVideo = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.courseware {
  height: 100%;
  .container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .anchor-item {
      position: absolute;
      margin-left: -30px;
      margin-top: -30px;
      width: 60px;
      height: 60px;
      font-size: 60px;
      cursor: pointer;
      z-index: 99;
      &.el-icon-video-play {
        color: #f56c6c;
      }
      &.el-icon-link {
        color: #e6a23c;
      }
    }
    ::v-deep .el-carousel {
      height: 100%;
      .el-carousel__container {
        height: 100%;
        .pptImg {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
        .el-carousel__arrow {
          width: 50px;
          height: 50px;
          background-color: rgb(236, 158, 55);
          font-size: 26px;
          box-shadow: 0 2px 6px 0 rgb(236, 158, 55, 10%);
          & > i {
            font-weight: bold;
            line-height: 50px;
          }
        }
      }
    }
  }
}
</style>